import formats from '../release-features.json';

export interface AdFormats { readonly rewarded: boolean; readonly banner: boolean; readonly interstitial: boolean }
if (Object.keys(formats).sort().join(',') !== 'banner,interstitial,rewarded'
    || Object.values(formats).some(value => typeof value !== 'boolean')) throw new Error('Invalid release ad formats');
export const adFormats: AdFormats = Object.freeze(formats);
